module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tea@3x_07b310.jpg";